import axios from "axios";
import { ref } from "vue";
import { defineStore } from "pinia";

export const useLicenseState = defineStore("license-state", () => {
  const licensePackageList = ref([]);

  async function initialize() {
    try {
      let res = await axios.post("/api/licensePackageData");
      licensePackageList.value = res.data;
    } catch (e) {
      console.log("Error loading license package data", e);
      licensePackageList.value = [];
    }
  }

  function hasLicensePackage(packageName) {
    if (!licensePackageList.value || licensePackageList.value.length === 0) {
      return false;
    }
    var pac = licensePackageList.value.find((p) => p.packageName.toLowerCase() === packageName.toLowerCase());
    if (!pac) {
      return false;
    }

    return !pac.isExpired;
  }

  return {
    initialize,
    hasLicensePackage,
    licensePackageList,
  };
});
